/* Tonuri Milan — looks: cart upsell only. PDP sidebar "Completa el look" removed. No popups. */
(function () {
  var LOOKS = [
    {
      id: "uniforme",
      name: "El uniforme de octubre",
      page: "/pages/look-el-uniforme-de-octubre",
      sum: 387,
      price: 329,
      save: 58,
      bundleId: 15979140120960,
      bundleByFalda: { "L/XL": 60030699864448, "S/M": 60030699831680 },
      pieces: [
        { id: 15967112724864, handle: "trench-camel-claro-con-forro", title: "Trench camel claro con forro", price: 139, add: "el trench camel" },
        { id: 15968755515776, handle: "jersey-oversize-cuello-chimenea-chocolate", title: "Jersey oversize cuello chimenea chocolate", price: 119, add: "el jersey chocolate" },
        { id: 15968130007424, handle: "falda-midi-negra-efecto-saten", title: "Falda midi negra efecto satén", price: 129, add: "la falda midi negra" }
      ]
    },
    {
      id: "marron",
      name: "Marrón chocolate",
      page: "/pages/look-marron-chocolate",
      sum: 268,
      price: 228,
      save: 40,
      pieces: [
        { id: 15967103844736, handle: "abrigo-marron-cruzado-efecto-ante", title: "Abrigo marrón cruzado efecto ante", price: 179, add: "el abrigo marrón" },
        { id: 15967166595456, handle: "vestido-basic-chocolate-corte-recto", title: "Vestido basic chocolate corte recto", price: 89, add: "el vestido chocolate" }
      ]
    },
    {
      id: "sastreria",
      name: "Sastrería suave",
      page: "/pages/look-sastreria-suave",
      sum: 258,
      price: 219,
      save: 39,
      pieces: [
        { id: 15968128991616, handle: "vestido-midi-fango-con-botones", title: "Vestido midi fango con botones", price: 139, add: "el vestido fango" },
        { id: 15967115936128, handle: "blazer-marron-estructurado", title: "Blazer marrón estructurado", price: 119, add: "el blazer marrón" }
      ]
    },
    {
      id: "camel",
      name: "Camel corto",
      page: "/pages/look-camel-corto",
      sum: 228,
      price: 194,
      save: 34,
      pieces: [
        { id: 15967104893312, handle: "abrigo-camel-corto-efecto-ante", title: "Abrigo camel corto efecto ante", price: 139, add: "el abrigo camel corto" },
        { id: 15967169905024, handle: "jersey-camel-holgado-cuello-alto", title: "Jersey camel holgado cuello alto", price: 89, add: "el jersey camel" }
      ]
    }
  ];

  function euro(n) { return n + " €"; }

  function findLook(handle) {
    for (var i = 0; i < LOOKS.length; i++) {
      for (var j = 0; j < LOOKS[i].pieces.length; j++) {
        if (LOOKS[i].pieces[j].handle === handle) return LOOKS[i];
      }
    }
    return null;
  }

  function mountPDP() {
    /* Beside-title aside.tonuri-completa is not rendered.
       Remove it if an older asset or template still left it in the DOM.
       Bottom section product_recommendations_qggXJq is untouched.
       Cart look notes below are unchanged. */
    document.querySelectorAll("aside.tonuri-completa").forEach(function (el) {
      el.remove();
    });
  }
  var lastSig = "";
  var swapping = false;

  function messagesFor(cart) {
    var notes = [];
    LOOKS.forEach(function (look) {
      var hasBundle = look.bundleId && cart.items.some(function (i) { return i.product_id === look.bundleId; });
      if (hasBundle) {
        notes.push({ kind: "done", text: look.name + " · Ahorras " + look.save + " €" });
        return;
      }
      var missing = look.pieces.filter(function (p) {
        return !cart.items.some(function (i) { return i.product_id === p.id; });
      });
      var present = look.pieces.length - missing.length;
      if (present === 0) return;
      if (missing.length === 0) {
        notes.push({ kind: "done", text: look.name + " · Ahorras " + look.save + " €" });
        return;
      }
      var href = missing.length === 1 ? "/products/" + missing[0].handle : look.page;
      var label = missing.map(function (p) { return p.add; }).join(" y ");
      notes.push({
        kind: "upsell",
        href: href,
        text: "Añade " + label + " y ahorra " + look.save + " €"
      });
    });
    return notes;
  }

  function mountCart(notes) {
    var sig = JSON.stringify(notes);
    var existing = document.querySelectorAll(".tonuri-cart-look");
    if (sig === lastSig && (notes.length === 0 || existing.length)) {
      if (notes.length === 0) existing.forEach(function (n) { n.remove(); });
      return;
    }
    lastSig = sig;
    existing.forEach(function (n) { n.remove(); });
    if (!notes.length) return;
    var anchors = document.querySelectorAll('button[name="checkout"], [name="checkout"]');
    if (!anchors.length) anchors = document.querySelectorAll(".cart-totals");
    var seen = [];
    anchors.forEach(function (btn) {
      var parent = btn.parentNode;
      if (!parent || seen.indexOf(parent) !== -1) return;
      seen.push(parent);
      var box = document.createElement("div");
      box.className = "tonuri-cart-look";
      box.innerHTML = notes.map(function (n) {
        if (n.kind === "upsell") {
          return '<p><a href="' + n.href + '">' + n.text + "</a></p>";
        }
        return "<p>" + n.text + "</p>";
      }).join("");
      if (btn.classList && btn.classList.contains("cart-totals")) parent.insertBefore(box, btn);
      else parent.insertBefore(box, btn);
    });
  }

  function maybeSwapUniforme(cart) {
    if (swapping) return Promise.resolve(false);
    var look = LOOKS[0];
    if (cart.items.some(function (i) { return i.product_id === look.bundleId; })) return Promise.resolve(false);
    var complete = look.pieces.every(function (p) {
      return cart.items.some(function (i) { return i.product_id === p.id; });
    });
    if (!complete) return Promise.resolve(false);
    swapping = true;
    var falda = cart.items.find(function (i) { return i.product_id === 15968130007424; });
    var title = (falda && falda.variant_title) || "";
    var variant = /L\/XL/.test(title) ? look.bundleByFalda["L/XL"] : look.bundleByFalda["S/M"];
    var updates = {};
    cart.items.forEach(function (i) {
      if (look.pieces.some(function (p) { return p.id === i.product_id; })) updates[i.key] = 0;
    });
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variant, quantity: 1 })
        });
      })
      .then(function () {
        location.reload();
        return true;
      })
      .catch(function () {
        swapping = false;
        return false;
      });
  }

  var timer = null;
  var refreshing = false;
  var lastCart = null;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refreshCart, 250);
  }

  function refreshCart() {
    if (refreshing) return;
    refreshing = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("cart " + r.status);
        return r.json();
      })
      .then(function (cart) {
        lastCart = cart;
        return maybeSwapUniforme(cart).then(function (swapped) {
          if (swapped) return;
          mountCart(messagesFor(cart));
        });
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  function boot() {
    mountPDP();
    var onCart = location.pathname.indexOf("/cart") === 0;
    if (onCart) refreshCart();
    document.addEventListener("cart:update", schedule);
    document.addEventListener("cart:updated", schedule);
    var drawer = document.querySelector("cart-drawer-component");
    if (drawer) {
      drawer.addEventListener("dialog:open", schedule);
      drawer.addEventListener("toggle", schedule);
    }
    document.addEventListener("click", function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest("cart-icon, a[href='/cart'], a[href$='/cart']")) schedule();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
